"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorStatus = void 0;
const react_1 = __importStar(require("react"));
const styled = __importStar(require("./styled"));
const Typography_1 = require("../Typography");
const AmountController_1 = __importDefault(require("../AmountController"));
const Types_1 = require("Types");
const cart_1 = require("@/Endpoints/cart");
const react_redux_1 = require("react-redux");
const Hooks_1 = require("@/Hooks");
const Utils_1 = require("@/Utils");
const Button_1 = __importDefault(require("../../Button"));
const SelectDropdownProduct_1 = __importDefault(require("../SelectDropdownProduct/SelectDropdownProduct"));
const useCommercePermissions_1 = __importDefault(require("../../../Hooks/useCommercePermissions"));
const cart_2 = require("@/Redux/Actions/cart");
const styled_components_1 = require("styled-components");
const VolumeDiscount_1 = __importDefault(require("./VolumeDiscount/VolumeDiscount"));
const StockAmount_1 = __importDefault(require("./StockAmount/StockAmount"));
const ProductView_1 = __importDefault(require("./ProductView/ProductView"));
const gtmEvents_1 = require("@/DataLayer/gtmEvents");
const types_1 = require("@/DataLayer/types");
const svg_components_1 = require("app/assets/svg-components");
const react_toastify_1 = require("react-toastify");
var ColorStatus;
(function (ColorStatus) {
    ColorStatus["Green"] = "green";
    ColorStatus["Yellow"] = "yellow";
    ColorStatus["Red"] = "red";
})(ColorStatus = exports.ColorStatus || (exports.ColorStatus = {}));
const AddToCart = props => {
    const { price, unitPrice, multiple, additionalCharge, stockStatus, discountInfo, packageSize, code, isAuthenticated, type, withAddButton, unit, onAmountChange, isLoading, setIsLoading, prices, quantity, miniCartUnitPrice, isOrderPrint, centerAlign, partNumber, productName, productBrand, productLineLogo, listName, listIndex, breadcrumbs, customerSpecificCode, productionStatusCode } = props;
    const [isInCart, setIsInCart] = (0, react_1.useState)(false);
    const [amount, setAmount] = (0, react_1.useState)(type === Types_1.VariantTypes.MINI_CART_VIEW ? quantity || 1 : packageSize || 1);
    const [currentPrice, setCurrentPrice] = (0, react_1.useState)(price);
    const [warningPrice, setWarningPrice] = (0, react_1.useState)('');
    const [warning, setWarning] = (0, react_1.useState)('');
    const { t, isReady } = (0, Hooks_1.useTranslate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const page = (0, Hooks_1.useCurrentPage)();
    const { unitDecode } = (0, Hooks_1.useUnits)();
    const { canSeePrice, canSeeStock, canMakeOrder, showLoginText } = (0, useCommercePermissions_1.default)(type, prices, stockStatus);
    const theme = (0, styled_components_1.useTheme)();
    const isNorthAmerica = (0, react_redux_1.useSelector)((state) => state.initialData.isNorthAmerica);
    const onSuccess = () => {
        setIsInCart(true);
        react_toastify_1.toast.success(t('/haldex/add_to_cart/added_successfully'));
    };
    const payloads = [
        {
            code: code,
            quantity: amount,
            action: Types_1.CartActions.UpdateItem
        }
    ];
    const cartDataLayer = (name) => {
        (0, gtmEvents_1.commonDataLayerEvent)([
            {
                amount,
                stockStatus,
                price,
                partNumber,
                productName,
                productBrand,
                productLineLogo,
                listName,
                listIndex,
                breadcrumbs,
                prices,
                productionStatusCode,
                customerSpecificCode
            }
        ], name, listName);
    };
    const handleSubmit = () => {
        if (amount % packageSize !== 0) {
            setWarning(`${t('/haldex/add_to_cart/qty_error')} ${packageSize}`);
        }
        else {
            (0, cart_1.addToCart)({ payloads, setIsLoading, dispatch, onSuccess });
            setWarning('');
            cartDataLayer(types_1.EDataLayerEventsNames.ADD_TO_CART);
        }
    };
    const handleChange = (newAmount) => {
        if (newAmount % packageSize !== 0) {
            setWarningPrice(`${(0, Utils_1.currencyEncoder)(miniCartUnitPrice.currencyCode)} ${(0, Utils_1.priceEncoder)(miniCartUnitPrice.amount * newAmount)}`);
            setWarning(`${t('/haldex/add_to_cart/qty_error')} ${packageSize}`);
        }
        else {
            onAmountChange(newAmount, setIsLoading, code);
            setWarning('');
        }
    };
    const createOptions = (packageSize) => {
        const options = [];
        for (let i = 1; i <= 20; i++) {
            options.push(packageSize * i);
        }
        return options;
    };
    (0, react_1.useEffect)(() => {
        if (type === Types_1.VariantTypes.MINI_CART_VIEW) {
            setCurrentPrice(price);
        }
        else if (isReady) {
            prices &&
                prices.forEach(price => {
                    amount >= parseInt(price.quantity) &&
                        price.itemPrice !== 0 &&
                        setCurrentPrice(type === Types_1.VariantTypes.PRODUCT_VIEW
                            ? `${price.currencySymbol}${(0, Utils_1.priceEncoder)(price.itemPrice)} / ${unitDecode(price.unitId)}`
                            : `${price.currencySymbol}${(0, Utils_1.priceEncoder)(price.itemPrice)}`);
                });
        }
    }, [amount, price, isReady]);
    (0, react_1.useEffect)(() => {
        if (type !== Types_1.VariantTypes.MINI_CART_VIEW) {
            setCurrentPrice(price);
        }
    }, [page]);
    (0, react_1.useEffect)(() => {
        type === Types_1.VariantTypes.MINI_CART_VIEW && setAmount(quantity || 1);
    }, [quantity]);
    const deleteFromCartHandler = () => {
        setIsLoading(true);
        (0, cart_1.deleteFromCart)({ code })
            .then(data => {
            cartDataLayer(types_1.EDataLayerEventsNames.REMOVE_FROM_CART);
            dispatch((0, cart_2.setCartData)(data.cart));
        })
            .finally(() => setIsLoading(false));
    };
    const showStock = !!(stockStatus === null || stockStatus === void 0 ? void 0 : stockStatus.length) && canSeeStock;
    return type === Types_1.VariantTypes.PRODUCT_VIEW ? (react_1.default.createElement(ProductView_1.default, { currentPrice: currentPrice, canSeePrice: canSeePrice, type: type, isAuthenticated: isAuthenticated, unitPrice: unitPrice, packageSize: packageSize, multiple: multiple, canMakeOrder: canMakeOrder, additionalCharge: additionalCharge, amount: amount, setAmount: setAmount, warning: warning, setWarning: setWarning, theme: theme, isLoading: isLoading, isInCart: isInCart, showLoginText: showLoginText, isNorthAmerica: isNorthAmerica, showStock: showStock, stockStatus: stockStatus, discountInfo: discountInfo, handleSubmit: handleSubmit, prices: prices })) : type === Types_1.VariantTypes.FULL_VIEW || Types_1.VariantTypes.MINI_CART_VIEW || Types_1.VariantTypes.CAROUSEL_VIEW ? (react_1.default.createElement(styled.PriceBlock, { variantType: type, centerAlign: centerAlign },
        (type === Types_1.VariantTypes.FULL_VIEW || type === Types_1.VariantTypes.CAROUSEL_VIEW) && currentPrice && canSeePrice && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(styled.PkgAmountBlock, null,
                react_1.default.createElement(styled.Price, { type: Typography_1.Types.H5, variantType: type }, currentPrice),
                currentPrice && unit && (react_1.default.createElement(styled.PriceUnit, { type: Typography_1.Types.BODY_2 }, ` /  ${unitDecode(unit)}`))),
            additionalCharge && (react_1.default.createElement(styled.CoreCharge, { type: Typography_1.Types.BODY_2 },
                t('/haldex/add_to_cart/core_charge'),
                " ",
                additionalCharge)))),
        showLoginText && (react_1.default.createElement(styled.NoAuth, { type: Typography_1.Types.BODY_2, variantType: type }, isNorthAmerica ? t('/haldex/add_to_cart/login_text_na') : t('/haldex/add_to_cart/login_text_eu'))),
        showStock && react_1.default.createElement(StockAmount_1.default, { stockStatus: stockStatus, isReady: isReady, type: type, isOrderPrint: isOrderPrint }),
        isAuthenticated && canMakeOrder && (react_1.default.createElement(react_1.default.Fragment, null,
            multiple && type !== Types_1.VariantTypes.MINI_CART_VIEW && (react_1.default.createElement(styled.PkgDescription, { type: Typography_1.Types.BODY_2 }, multiple)),
            react_1.default.createElement(styled.AmountBlock, { variantType: type, isOrderPrint: isOrderPrint },
                packageSize > 1 ? (react_1.default.createElement(styled.SelectContainer, { variantType: type },
                    react_1.default.createElement(SelectDropdownProduct_1.default, { options: createOptions(packageSize), width: 103, quantity: amount, onChange: newAmount => {
                            withAddButton && setAmount(newAmount);
                            !withAddButton && onAmountChange && handleChange(newAmount);
                        }, setWarning: setWarning }))) : (react_1.default.createElement(AmountController_1.default, { maxWidth: type === Types_1.VariantTypes.MINI_CART_VIEW
                        ? theme.constants.amountControllerWidth.cartWidth
                        : type === Types_1.VariantTypes.CAROUSEL_VIEW
                            ? theme.constants.amountControllerWidth.carouselWidth
                            : theme.constants.amountControllerWidth.fullWidth, minWidth: type === Types_1.VariantTypes.FULL_VIEW ? theme.constants.amountControllerWidth.fullWidth : 0, quantity: amount, onChange: newAmount => {
                        !withAddButton && onAmountChange && handleChange(newAmount);
                    }, disabled: isLoading, setQuantity: withAddButton && setAmount })),
                type !== Types_1.VariantTypes.MINI_CART_VIEW && withAddButton && (react_1.default.createElement(Button_1.default, { variant: Types_1.ButtonVariants.DEFAULT, disabled: isLoading, onClick: handleSubmit }, t('/haldex/add_to_cart/button_add'))),
                type === Types_1.VariantTypes.MINI_CART_VIEW && (react_1.default.createElement(styled.TotalPriceBlock, null,
                    currentPrice && canSeePrice && (react_1.default.createElement(styled.TotalPrice, { type: Typography_1.Types.EYEBROW }, warning ? warningPrice : currentPrice)),
                    react_1.default.createElement(styled.CrossButton, { onClick: deleteFromCartHandler },
                        react_1.default.createElement(svg_components_1.CrossIcon, null))))),
            type === Types_1.VariantTypes.FULL_VIEW && (discountInfo === null || discountInfo === void 0 ? void 0 : discountInfo.length) && react_1.default.createElement(VolumeDiscount_1.default, { discountInfo: discountInfo }),
            warning && react_1.default.createElement(styled.Warning, { type: Typography_1.Types.BODY_2 }, warning))))) : (react_1.default.createElement("div", null, "compare component"));
};
exports.default = (0, react_1.memo)(AddToCart);
